<div class="flex flex-col gap-1 flex-1">
  <div class="flex flex-row gap-1">
    <snt-button-icon
      icon="fa-light fa-align-left"
      (onClick)="onAlignChanged('left')"
      [sntTooltip]="'Allinea a sinistra' | transloco"
      [type]="align() === 'left' ? 'primary' : 'default'"
    ></snt-button-icon>

    <snt-button-icon
      icon="fa-light fa-align-center"
      [sntTooltip]="'Allinea al centro' | transloco"
      (onClick)="onAlignChanged('center')"
      [type]="align() === 'center' ? 'primary' : 'default'"
    ></snt-button-icon>

    <snt-button-icon
      icon="fa-light fa-align-right"
      [sntTooltip]="'Allinea a destra' | transloco"
      (onClick)="onAlignChanged('right')"
      [type]="align() === 'right' ? 'primary' : 'default'"
    ></snt-button-icon>
  </div>

  <dx-text-area
    [value]="caption()"
    [placeholder]="'Didascalia' | transloco"
    (onValueChanged)="onCaptionValueChanged($event)"
  ></dx-text-area>
</div>
